
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collezioni/brand/[slug_brand]",
      function () {
        return require("private-next-pages/collezioni/brand/[slug_brand]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collezioni/brand/[slug_brand]"])
      });
    }
  